import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, TS_Table } from '@nu-art/thunderstorm-frontend/index';
class PgDev_TS_Table_Class extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return;
    }
    render() {
        const rows = new Array(10).fill(0).map((item, i) => {
            return { col1: i, col2: i, col3: i, col4: i };
        });
        return _jsx(TS_Table, { rows: rows, header: ['col1', 'col2', 'col3', 'col4'], headerRenderer: item => _jsx("div", { children: item }), cellRenderer: (prop, item, index) => _jsxs("div", { children: [prop, " - cell ", index] }), tr: (r, i) => ({
                className: i === 3 ? 'selected' : undefined,
            }) });
    }
}
export const PgDev_TS_Table = { name: 'TS_Table', key: 'tables-tests', renderer: PgDev_TS_Table_Class };
